/*
 * Assumes there is a bogo offer set up in the backend in which
 * buying any product gets the user their choice of free product.
 * A metaobject needs to be set up that contains the free product
 * options and an enabled switch.
 */ 
class BogoManager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const productIdsString = this.getAttribute('product-ids');
    this.offerProductIds = productIdsString ? productIdsString.split(',').map(id => id.trim()) : [];
    this.dialogElement = this.querySelector("dialog");
    this.form = this.querySelector("form");
    this.closeBtn = this.querySelector("button.close");
    console.log(this.closeBtn);
    this.productRadios = this.querySelectorAll('input[type="radio"]');

    let boundSubmit = this.submitBogoForm.bind(this);
    this.form?.addEventListener("submit", boundSubmit)

    let boundBtnClick = this.closeBogoModal.bind(this);
    this.closeBtn.addEventListener("click", boundBtnClick)

    // Seed previousCartTotal so quantity-change transitions can be detected
    fetch('/cart.js').then(res => res.json()).then(cart => {
      this.previousCartTotal = cart.total_price;
    });
  }
  
  async openBogoModal(items) {
    const qualifies = await this.qualifiesForBogo(items);
    if (!qualifies) return;

    this.dialogElement.showModal();
  }

  async submitBogoForm(e) {
    e.preventDefault();
    const selection = [...this.productRadios].find(radio => radio.checked).value;
    const result = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: selection,
          quantity: 1,
          properties: {
            '_bogo_offer': 'true'
          }
        }]
      })
    })
    .then(res => res.json())
    console.log(result);
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  if (cartItems && cartItems.onCartUpdate) {
    cartItems.onCartUpdate();
  }
    this.closeBogoModal();
  }

  closeBogoModal() {
    this.dialogElement.close();
    this.selection = null;
  }

  async handleCartQuantityUpdate(cartData) {
    const prevTotal = this.previousCartTotal ?? cartData.total_price;
    this.previousCartTotal = cartData.total_price;

    // Only show if cart total just crossed the $5 threshold upward
    if (prevTotal >= 500 || cartData.total_price < 500) return;

    // Don't show if a bogo offer is already in the cart
    const hasOfferInCart = cartData.items.some(item =>
      item.properties && item.properties._bogo_offer === 'true'
    );
    if (hasOfferInCart) return;

    this.dialogElement.showModal();
  }

  async qualifiesForBogo(addedVariantId) {
    console.log("added variant ID: ", addedVariantId);
    
    // Don't show modal if they just added an offer product
    //if (this.offerProductIds.includes(String(addedVariantId))) {
    //  return false;
    //}
    
    // Check if cart already has an offer product
    const cart = await fetch('/cart.js').then(res => res.json());

    console.log("CART: ",cart);

    if (cart.total_price < 500) return; 

    const hasOfferInCart = cart.items.some(item => 
      item.properties && item.properties._bogo_offer === 'true'
    );
    
    if (hasOfferInCart) return false;
    
    // If we got here, they added a regular product and no offer exists
    return true;
  }
}

customElements.define('bogo-manager', BogoManager);
